module.exports = __webpack_public_path__ + "fonts/ropa-sans-v9-latin-ext_latin-italic.woff2?8d3c313d42c9d8ed6dac6483ed5770f5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ropa-sans-v9-latin-ext_latin-italic.woff2
// module id = 314
// module chunks = 0